<template>
  <CSidebar
    colorScheme="light"
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <!--logo header-->
    <CSidebarBrand class="d-md-down-none" @click="goToHomePage()" style="padding: 10px; background-color: white;">
      <img
        src="@/assets/Asset 2@2x.png"
        class="c-sidebar-brand-full"
        name="logo"
        size="custom-size"
        viewBox="0 0 556 134"
        width="100%"
        height="auto"
        style="padding: 0 20px;"
      />
      <img
        src="@/assets/Asset 2@2x.png"
        class="c-sidebar-brand-minimized"
        name="logo"
        size="custom-size"
        viewBox="0 0 110 134"
        width="100%"
        height="auto"
      />
      <!--            <img-->
      <!--                    src="@/assets/Asset%202@2x.png"-->
      <!--                    class="c-sidebar-brand-full"-->
      <!--                    name="logo"-->
      <!--                    size="custom-size"-->
      <!--                    height="50"-->
      <!--                    viewBox="0 0 556 134"-->
      <!--            />-->
      <!--            <img-->
      <!--                    src="@/assets/Asset%202@2x.png"-->
      <!--                    class="c-sidebar-brand-minimized"-->
      <!--                    name="logo"-->
      <!--                    size="custom-size"-->
      <!--                    height="35"-->
      <!--                    viewBox="0 0 110 134"-->
      <!--            />-->
    </CSidebarBrand>

    <!--all menu in side bar-->
    <CRenderFunction flat :content-to-render="$options.nav" />

    <!--all menu in side barmini
        <CSidebarMinimizer
          class="d-md-down-none"
          @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />-->
  </CSidebar>
</template>

<script>
import nav from "./_nav";
import '../../assets/scss/_adminStyle.scss'

export default {
  name: "TheAdminSidebar",
  nav,
  data() {
    return {
      showSidebar: false,
    };
  },
  computed: {
    show() {
      this.showSidebar = this.$store.state.sidebarShow
      return this.showSidebar;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
  methods: {
    goToHomePage() {
      this.$store.commit("language/setChangingSidebar", false);
      this.$router.push("/Homepage");
    },
  },
};
</script>
<style >
.c-sidebar.c-sidebar-light .c-sidebar-nav-link:hover, .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown-toggle:hover{
  background-color: #FB9879 !important;
  color: black !important;
}
</style>